export const eventsData = {
  liveEvents: [
    // {
    //   title: "Teach a machine in 2 hours",
    //   date: "26 oct 2025",
    //   location: "Online",
    //   description: "Join us for an insightful expert talk on AI and machine learning.",
    //   link: "https://fewinfos.com/register",
    //   buttonText: "Register Now"
    // }
  ],
  upcomingEvents: [
    // {
    //   title: "Teach a machine in 2 hours",
    //   date: "26 oct 2025",
    //   location: "Online",
    //   description: "Join us for an insightful expert talk on AI and machine learning.",
    //   link: "https://fewinfos.com/register",
    //   buttonText: "Register Now"
    // }
  ],
  pastEvents: [

    {
      title: "AI Innovation Summit",
      date: "MAY 14-16, 2025",
      location: "MKCE - Karur, India",
      description: "Explore the future of AI and machine learning with top experts and leaders. (code : FIW251)",
      image: require("../assets/images/16.jpg"),
      link: "https://fewinfos.online/gallery.html",
      buttonText: "View Highlights",
    },
    {
      title: "AI tools workshop",
      date: "July 13(7pm - 9pm), 2025",
      location: "Online",
      description: "Get to know about the life changing AI tools",
      link: "https://fewinfos.online/gallery.html",
      buttonText: "visit Highlights",
    },
    {
      title: "Teach a machine in 2 hours",
      date: "26 oct 2025",
      location: "Online",
      description: "Join us for an insightful expert talk on AI and machine learning.",
      link: "https://fewinfos.online/gallery.html",
      buttonText: "visit Highlights"
    }
  ],
};
